import { useContext } from "react";
import { SurveyFormContext } from "@/components/common/resource-survey/components/survey-form/survey-form-context";
import { Textarea } from "@/components/ui/textarea";

export const SurveyText = ({ index }: { index: number }) => {
  const { setStepsAnswers, stepsAnswers, currentStep } =
    useContext(SurveyFormContext);

  const stepAnswers = stepsAnswers[currentStep];
  const { value } = stepAnswers[index] as { value: string };

  return (
    <Textarea
      placeholder={"Twoja odpowiedź"}
      onChange={({ target }: { target: HTMLTextAreaElement }) => {
        setStepsAnswers((draft) => {
          draft[currentStep][index].value = target.value;
        });
      }}
      value={value}
    />
  );
};
